import Logo from "@/components/Logo/Logo";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Navbar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const refererId = params.get("refererId");
  var topPageURL = "https://koyouassess.biz/";
  if ( refererId === "soumu-madoguchi" ) {
    topPageURL = "https://soumu-madoguchi.co.jp/service/foreign-worker/";
  }
  console.log('topPageURL:', topPageURL);

  return (
    <div className="fixed left-0 right-0 top-0 z-20 flex h-16 items-center justify-between bg-white px-6 shadow">
      <Logo href={topPageURL} />
      <div className="flex items-center gap-3">
        <Button variant="outline" onClick={() => navigate("/app/login")}>
          {t("login")}
        </Button>
      </div>
    </div>
  );
}

export default Navbar;
